import { createElement, ReactNode } from 'react';

interface FormaTabsProps extends React.HTMLAttributes<HTMLElement> {
	selectedtab?: number;
	gap?: number;
	density?: 'high' | 'medium';
	children?: ReactNode;
}

export function FormaTabs({
	className,
	selectedtab = 0,
	gap = 8,
	density = 'high',
	children,
	...rest
}: FormaTabsProps) {
	return createElement('forma-tabs', {
		className,
		selectedtab,
		gap,
		density,
		...rest,
	},
		children,
	);
}

interface FormaTabProps extends React.HTMLAttributes<HTMLElement> {
	for: string;
	label: string;
	hpadding?: number;
	disabled?: boolean;
}

export function FormaTab({
	className,
	for: htmlFor,
	label,
	hpadding = 0,
	disabled = false,
	...rest
}: FormaTabProps) {
	return createElement('forma-tab', {
		className,
		for: htmlFor,
		label,
		hpadding,
		disabled,
		...rest,
	});
}
